// extracted by mini-css-extract-plugin
export default {"LoaderWrap":"Loader_LoaderWrap__CyX4a","LoadBox":"Loader_LoadBox__13KUK","LoadRow":"Loader_LoadRow__Vs9-1","up-down6":"Loader_up-down6__iT8Uq"};